module.exports = {"name":"summaryBoxSize","value":{"width":15,"height":20}}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/signals/inputs/summary-box-size.json
// module id = e7cs
// module chunks = 0